import { PAGE_CODES } from 'constants/pageCodes';
import { lazyWithRetry } from 'utils/chunkLoadRecovery';
import { EnhancedPath } from 'utils/history';

const WAREHOUSES_ROUTING_PARAMS = {
  bankId: 'bankId',
  section: 'section',
  lineId: 'lineId',
  tab: 'tab',
};

export class AccountingPaths {
  static purchaseAdvice = new EnhancedPath('/purchase-advice');
  static advance = new EnhancedPath('/advance');
  static purchasedLoans = new EnhancedPath('/purchased-loans');
  static investors = new EnhancedPath('/investors');
  static warehouses = new EnhancedPath('/warehouses');
  static warehouseBank = new EnhancedPath(
    `${AccountingPaths.warehouses.path}/:${WAREHOUSES_ROUTING_PARAMS.bankId}/:${WAREHOUSES_ROUTING_PARAMS.section}?/:${WAREHOUSES_ROUTING_PARAMS.lineId}?/:${WAREHOUSES_ROUTING_PARAMS.tab}?`,
  );
  static optimizationStrategies = new EnhancedPath('/warehouses/optimization-strategies');
  static dealers = new EnhancedPath('/dealers');
  static servicingCompanies = new EnhancedPath('/servicing-companies');
}

const routesConfig = {
  settings: {
    layout: {},
  },
  routes: [
    {
      path: AccountingPaths.purchaseAdvice.path,
      component: lazyWithRetry(() => import('app/pages/system/purchaseAdvice')),
      pageCode: PAGE_CODES.PURCHASE_ADVICE,
    },
    {
      path: AccountingPaths.advance.path,
      component: lazyWithRetry(() => import('app/pages/system/advance')),
      pageCode: PAGE_CODES.ADVANCE,
    },
    {
      path: AccountingPaths.purchasedLoans.path,
      component: lazyWithRetry(() => import('app/pages/system/purchasedLoans')),
      pageCode: PAGE_CODES.PURCHASED_LOANS,
    },
    {
      path: AccountingPaths.investors.path,
      component: lazyWithRetry(() => import('app/pages/system/investors')),
      pageCode: PAGE_CODES.INVESTORS,
    },
    {
      path: AccountingPaths.optimizationStrategies.path,
      component: lazyWithRetry(() => import('app/pages/system/warehouses/OptimizationStrategies')),
      pageCode: PAGE_CODES.WAREHOUSE_BANKS,
    },
    {
      path: AccountingPaths.warehouseBank.path,
      component: lazyWithRetry(() => import('app/pages/system/warehouses')),
      pageCode: PAGE_CODES.WAREHOUSE_BANKS,
    },
    {
      path: AccountingPaths.warehouses.path,
      component: lazyWithRetry(() => import('app/pages/system/warehouses')),
      pageCode: PAGE_CODES.WAREHOUSE_BANKS,
    },
    {
      path: AccountingPaths.dealers.path,
      component: lazyWithRetry(() => import('app/pages/system/dealers')),
      pageCode: PAGE_CODES.DEALERS,
    },
    {
      path: AccountingPaths.servicingCompanies.path,
      component: lazyWithRetry(() => import('app/pages/system/servicingCompanies')),
      pageCode: PAGE_CODES.SERVICING_COMPANY,
    },
  ],
};

export default routesConfig;
